<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>Can I get a refund ?</b>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p>Unfortunately, No! After you've got access to the repo, JanguKit is yours forever, so it can't be refunded..</p>

  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>How can I get an invoice?</b>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    In the My Subscriptions section, you can find an invoice for your most recent subscription.
    If you are billed monthly, the latest invoice is generated automatically each month.
    If you need to make changes to your invoice, please go to the complaints section and provide the information you would like on
    your invoice by completing the 'Invoice Request' form.
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <b>Other questions and requests</b>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p>
      You can send us a message by clicking the button below.
      We will do our best to respond as quickly as possible.</p>
    <mat-action-row>
      <button mat-button color="warn" (click)="openDialog()" >Send a request</button>
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
